import React, {FC, useState} from 'react';

/*
 * Props.
 */

interface RandomImageProps {
  urls: ReadonlyArray<string>;
  height: number;
  width: number;
  alt: string;
}

/*
 * Component.
 */

export const RandomImage: FC<RandomImageProps> = ({urls, height, width, alt}) => {
  const [randomValue] = useState(() => Math.random());
  const randomIndex = Math.floor(randomValue * urls.length);
  return <img src={urls[randomIndex]} width={width} height={height} alt={alt} />;
};
